import { createAction, props } from '@ngrx/store';
import {
  AccountIntegrations,
  IntegrationDetails,
  IntegrationID,
  IntegrationsDetails,
} from './interfaces';

// Get Integrations
export const getIntegrationsAction = createAction(
  '[Integrations] Get Integrations',
);
export const getIntegrationsSuccessAction = createAction(
  '[Integrations] Get Integrations Success',
  props<{ integrations: IntegrationsDetails[] }>(),
);
export const getIntegrationsFailAction = createAction(
  '[Integrations] Get Integrations Fail',
);

// Get Integration
export const getIntegrationAction = createAction(
  '[Integration] Get Integration',
  props<{ id: IntegrationID }>(),
);
export const getIntegrationSuccessAction = createAction(
  '[Integrations] Get Integration Success',
  props<{ integration: IntegrationDetails }>(),
);
export const getIntegrationFailAction = createAction(
  '[Integration] Get Integration Fail',
);

// Get Account Integrations
export const getAccountIntegrationsAction = createAction(
  '[Integration] Get Account Integrations',
  props<{ accountId: string }>(),
);
export const getAccountIntegrationsSuccessAction = createAction(
  '[Integrations] Get Account Integrations Success',
  props<{ accountIntegrations: AccountIntegrations[] }>(),
);
export const getAccountIntegrationsFailAction = createAction(
  '[Integration] Get Account Integrations Fail',
);
